<template>
  <div>
    <b-modal class="popup" :active.sync="isCardModalActive" :width="515" scroll="keep" @close="$root.$emit('update_feature_type')">
      <div class="card" style="border-radius:10px;min-height:400px">
        <div class="card-header">
          <div class="card-header-title is-semibold-18-600-22 modal-title">
            {{ localization("app-create-modify-feature-types", "Create / Modify feature types") }}
          </div>
          <div class="card-header-icon modal-title" @click="$root.$emit('update_feature_type');isCardModalActive = false">
            <img src="../../../../../../../assets/icons/close.svg" alt="" srcset="" />
          </div>
        </div>
        <div class="card-content">
          <features v-if="isCardModalActive"></features>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import features from "./feature-type-groups/features-type-groups";

export default {
  data() {
    return {
      isCardModalActive: false,
    };
  },
  components: {
    features,
  },
  created() {
    this.$root.$on("create_modal", () => {
      this.isCardModalActive = true;
    });
  },
};
</script>

<style lang="scss">
.modal-title {
  padding: 20px 30px !important;
}
.popup .card {
  background-color: #f4f7fc;
}
.popup .card .card-header {
  background-color: #fff;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
}
</style>
